import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.menuKey = ''
      this.menuName = ''
      this.visible = ''
    }
  }
}
export default searchFrom
